/**
 *
 * Disclaimer: Source code mentioned below is(are) Intellectual Property of
 * Crayon Data Holdings Limited (including its subsidiaries and affiliates).
 * Crayon Data Holdings Limited reserves right to own and control it the way
 * it may deem fit. You must refrain from use, access, read, modify, add or
 * delete, sell or use in any other package or programme pertaining to such
 * source code without explicit prior written approval of
 * Crayon Data Holding Limited. Breach of the same shall attract penalty as
 * applicable.
 *
 */

class config {
  constructor() {
    this.domain = "https://offer-mgmt-stage-api.testmaya.com";
    this.version = "/api/v1";
    this.locKey = "AIzaSyDn4QwXk4G0Zcfurqv2MSAZxcKNQ_Ro5Gs"
  }
 
}

export default new config();